import { labeled, numberRequired } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  Joi.object().keys({
    purposeFunds: numberRequired(Joi, 1).label(labeled(label, 'Security value'))
  });

export default {
  schema
};
